import React from "react";
import Html from "../images/html.png";
import Css from "../images/css.png";
import JavaScript from "../images/javascript.png";
import Typescript from "../images/typescript.png";
import Tailwind from "../images/tailwind.png";
import Sass from "../images/sass.png";
import Node from "../images/node.png";
import ReactFoto from "../images/react.png";
import Native from "../images/native.png";
import Graph from "../images/graphql.png";
import Next from "../images/next.png";

import Kubernetes from "../images/kubernetes.png"
import Docker from "../images/docker.png"
import Git from "../images/git.png"
import Npm from "../images/npm.png"
import Visual from "../images/visual.png"
import Github from "../images/github.png"
import PWA from "../images/pwa.png"
import StoryBook from "../images/storybook.png"

import First from "../images/first.png"
import Skill from "../images/skill.png"
import Yo from "../images/yo1.png"

const Misconocimientos = () => {
  return (
    <div id="habilidades" className="h-screen mt-10 justify-center flex items-center">
      <div className=" w-full ">
        <div className="flex">
          <div className="md:w-9/12 w-full  ">
            <h4 className="lg:text-5xl md:text-3xl text-xl text-center  text-gray-300"> <a className="text-emerald-300">02.</a> Lenguajes y frameworks</h4> 
           
            <div className="mt-16  grid grid-cols-4 gap-6">
              <div className="">
                <img alt="HTML" className="w-20  duration-300  delay-150 hover:-translate-y-1 hover:scale-110 transition" src={Html} />
              </div>
              <div className="flex">
                <img alt="CSS" src={Css} className=" w-20 rounded-xl duration-300  delay-150 hover:-translate-y-1 hover:scale-110 transition" />
              </div>
              <div className="flex ">
                <img
                  alt="javascript"
                  src={JavaScript}
                  className="w-20 duration-300 rounded-xl  delay-150 hover:-translate-y-1 hover:scale-110 transition "
                />
              </div>
              <div className="flex">
                <img
                  alt="Typescript"
                  src={Typescript}
                  className="w-20 duration-300  rounded-xl
                   delay-150 hover:-translate-y-1 hover:scale-110 transition"
                />
              </div>
              <div className="flex">
                <img alt="Tailwind" className="w-20 duration-300  delay-150 hover:-translate-y-1 hover:scale-110 transition" src={Tailwind} />
              </div>
              <div>
                <img alt="Sass" src={Sass} className="w-20 duration-300  delay-150 hover:-translate-y-1 hover:scale-110 transition rounded-xl" />
              </div>
              <div className=" flex">
                <img alt="Nodejs" src={Node} className="w-20  duration-300  delay-150 hover:-translate-y-1 hover:scale-110 transition rounded-xl" />
              </div>
              <div className="flex">
                <img alt="React" src={ReactFoto} className="w-20  duration-300  delay-150 hover:-translate-y-1 hover:scale-110 transition" />
              </div>
              <div>
                <img alt="React native" src={Native} className="w-20  duration-300  delay-150 hover:-translate-y-1 hover:scale-110 transition" />
              </div>
              <div>
                <img src={Next} className="w-20  duration-300  delay-150 hover:-translate-y-1 hover:scale-110 transition" alt="NextJS" />
              </div>
              <div className="flex">
                <img src={Graph} className="w-20  duration-300  delay-150 hover:-translate-y-1 hover:scale-110 transition" alt="GraphQL" />
              </div>
            </div>
          </div>
          <div className="md:w-3/12 md:flex hidden ">
            <img src={Skill} className="w-full h-full  duration-300  delay-150 hover:-translate-y-1 hover:scale-110 transition" alt="Imagen code"/>
          </div>
        </div>
     
        <div className="w-full  md:flex mt-6 ">
          <div className="md:w-9/12 w-full">
            <h4 className="text-gray-300 text-center mt-10 md:text-3xl text-xl lg:text-5xl "> {'>'} Herramientas</h4>
            <div className="flex mt-10 grid grid-cols-4 gap-6 w-full  ">
              <div className="flex">
                <img className="w-20  duration-300  delay-150 hover:-translate-y-1 hover:scale-110 transition" src={Github} alt="GitHub" />
              </div>
              <div className="flex ">
                <img src={Git} className="w-20  duration-300  delay-150 hover:-translate-y-1 hover:scale-110 transition" alt="Git" />
              </div>
              <div className="flex">
                <img className="w-20  duration-300  delay-150 hover:-translate-y-1 hover:scale-110 transition" src={Docker} alt="Docker" />
              </div>
              <div>
                <img src={Kubernetes} className="w-20  duration-300  delay-150 hover:-translate-y-1 hover:scale-110 transition" alt="Kubernetes" />
              </div>
              <div>
                <img src={Visual} className="w-20  duration-300  delay-150 hover:-translate-y-1 hover:scale-110 transition" alt="Visual Estudio Code" />
              </div>
              <div className="">
                <img src={Npm} alt="NPM" className="w-20 mt-6 duration-300  delay-150 hover:-translate-y-1 hover:scale-110 transition" />
              </div>
              <div className="">
                <img src={PWA} alt="Image PWA"  className="w-20 mt-6 duration-300  delay-150 hover:-translate-y-1 hover:scale-110 transition"/>
              </div>
              <div>
                <img src={StoryBook} alt="Image StoryBook" className="w-20 mt-6 duration-300  delay-150 hover:-translate-y-1 hover:scale-110 transition"/>
              </div>
            </div>
           
          </div>
           <div className="md:w-3/12 md:flex hidden ">
              <img src={Yo} alt="Foto codigo" className="w-full h-full  duration-300  delay-150 hover:-translate-y-1 hover:scale-110 transition"/>
            </div>
        </div>
      </div>
    </div>
  );
};

export default Misconocimientos;
